import { ObjectDirective } from "vue"

const directive: ObjectDirective = {
    inserted(el, node) {
        el.addEventListener("click", () => {
            let menu = el.closest(".menu");
            if (menu) {
                menu.classList.remove("show");
            }
        });
    }
};

export default directive;